<div class="cookies-message" *ngIf="!mostrarAvisoCookies">
    <span class="texto">Utilizamos cookies para oferecer melhor experiência, melhorar o desempenho, analisar como você interage em nosso site e personalizar conteúdo.
        <br>Ao utilizar este site, você concorda com o uso de cookies. Clique aqui para conferir nossa <a routerLink="/institucional/lgpd"><strong><span class="underline">Política de Privacidade.</span></strong></a></span>
    <button type="button" class="botao" (click) = "estouCiente()">Estou ciente</button>
</div>
